export const CLI_AUTH_SESSION_KEY = 'cliAuthSessionId'
export const SESSION_ID_REGEX = /^[0-9a-f]{64}$/i

export function isValidSessionId(sessionId: unknown): sessionId is string {
  return typeof sessionId === 'string' && SESSION_ID_REGEX.test(sessionId)
}

export function getSessionIdFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('sessionId') || null
}

export function storeSessionId(sessionId: string): void {
  if (isValidSessionId(sessionId)) {
    localStorage.setItem(CLI_AUTH_SESSION_KEY, sessionId)
  }
}

export function getStoredSessionId(): string | null {
  return localStorage.getItem(CLI_AUTH_SESSION_KEY)
}

export function clearStoredSessionId(): void {
  localStorage.removeItem(CLI_AUTH_SESSION_KEY)
}
